import { useState, useRef, forwardRef, useEffect } from "react";

import {
  Stack,
  Box,
  Button,
  Fade,
  Typography,
  Grid,
  Divider,
  Modal,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from "@mui/material";

import ActiveIcon from "assets/icons/active.svg";
//slider
import Slider from "react-slick";
//style
import { styled } from "@mui/material/styles";
import { SvgIconStyle } from "components";

//ui data
import {
  IntroList,
  FbText,
  FbRound,
  TicketRound,
  TicketList,
  LockerItems,
} from "utils/uiData";

//dummy
import { LockerList, EtcList, NoticeList } from "utils/dummyData";
//images
import PortImg from "assets/images/port-img.png";
import FbImg from "assets/images/intro-1.png";
import Ticket from "assets/images/intro-2.png";
import ArrowLeft from "assets/icons/left-arrow.svg";
import ArrowRight from "assets/icons/right-arrow.svg";
import CloseBtnIcon from "assets/icons/close-btn.svg";

export function SideNavButton({ label, active, ...other }) {
  return (
    <Box
      sx={{
        p: "0 50px 30px 15px",
        position: "relative",
        ":after": {
          content: "''",
          position: "absolute",
          width: active ? "13px" : "5px",
          height: active ? "13px" : "5px",
          borderRadius: "10rem",
          backgroundColor: "primary.light",
          background: active
            ? `center/contain no-repeat url(${ActiveIcon})`
            : "primary.light",
          top: active ? 0 : 4,
          left: active ? "-6px" : "-2px",
        },
        ":not(:last-child)": {
          ":before": {
            content: "''",
            position: "absolute",
            borderLeft: "1px solid",
            borderColor: "grey.500",
            height: "110%",
            top: 5,
            left: 0,
          },
        },
      }}
    >
      <Button
        sx={{
          display: "block",
          textAlign: "start",
          p: 0,
          color: active ? "primary.main" : "grey.100",
          lineHeight: 1,
        }}
        {...other}
      >
        {label}
      </Button>
    </Box>
  );
}

export const ServiceComp = {
  Intro: () => (
    <>
      <Typography variant="h4" color={"primary.main"} mb={2}>
        페스티벌의 기다림 없는 즐거움,
        <br />
        <Box
          component="span"
          sx={{
            color: "black",
            fontWeight: 400,
          }}
        >
          퀸즈가 만들어 갑니다.
        </Box>
      </Typography>
      <Grid container spacing={3}>
        {IntroList.map((item, i) => (
          <Grid key={i} item xs={12} sm={6} md={4}>
            <Box
              sx={{
                position: "relative",
                height: "100%",
              }}
            >
              <Box
                component="img"
                src={item.src}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 1.5,
                  filter: "brightness(30%)",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <Typography variant="title3">{item.title}</Typography>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "pre",
                    lineHeight: 1.2,
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  ),

  Fb: () => (
    <>
      <Typography variant="h4" color={"primary.main"}>
        F&B
      </Typography>
      <Stack direction="row" alignItems="flex-start" spacing={5} sx={{ mt: 2 }}>
        {/* img */}
        <Box
          component="img"
          src={FbImg}
          sx={{
            width: "26%",
            borderRadius: 1.5,
          }}
        />
        {/* text */}
        <Box>
          <Typography variant="h6">
            시간 예약 알고리즘으로 대기열 없는 푸드존
          </Typography>
          <Typography variant="body2" my={2} lineHeight={1.5}>
            *시간 예약 알고리즘: 상품의 특성과 고객의 수요를
            <br />
            &nbsp;&nbsp;예측하고 현장의 푸드존 운영 상황에 맞추어 시간의 단위를
            세분화한 예약을 제공하는 규칙
          </Typography>
          {FbText.map((text) => (
            <Typography
              key={text}
              variant="body1"
              sx={{
                whiteSpace: "pre-line",
                lineHeight: 1.5,
                mt: 2,
              }}
            >
              {text}
            </Typography>
          ))}
          {/* 동그라미 */}
          <RoundText items={FbRound} sx={{ mt: 5 }} />
        </Box>
      </Stack>
    </>
  ),
  Ticket: () => (
    <>
      <Typography variant="h4" color={"primary.main"}>
        E-ticket
      </Typography>
      <Stack direction="row" alignItems="flex-start" spacing={5} sx={{ mt: 2 }}>
        {/* img */}
        <Box
          component="img"
          src={Ticket}
          sx={{ width: "26%", borderRadius: 1.5 }}
        />
        {/* text */}
        <Box>
          <Typography variant="h6" mb={2}>
            입장 소요시간 단 3초, 디지털 스마트 솔루션
          </Typography>
          {[
            {
              left: "TypeA",
              center: "예매처 데이터 통합 관리 및 입장 운영",
              right:
                "국내 14개 모든 예매처 데이터를 통합해 티켓을 관리하며\n사전 관리부터 현장 입장 운영까지 총괄합니다.",
            },
            {
              left: "TypeB",
              center: "티켓 판매 및 입장 운영",
              right:
                "퀸즈 사이트를 통해 티켓을 판매하며 판매된 E-ticket의\n사전 관리부터 현장 입장 운영까지 총괄합니다.",
            },
          ].map((item, i) => (
            <Stack
              key={i}
              direction="row"
              sx={{
                height: 30,
                mb: 3,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  border: "1px solid black",
                  borderRadius: "20px 0px 0px 20px",
                  px: 2,
                  bgcolor: "black",
                  color: "white",
                }}
              >
                {item.left}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  border: "1px solid black",
                  px: 2,
                  whiteSpace: "nowrap",
                  width: "33%",
                }}
              >
                {item.center}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  borderTop: "1px solid black",
                  lineHeight: 1.2,
                  py: 0.5,
                  pl: 2,
                  whiteSpace: "pre",
                }}
              >
                {item.right}
              </Typography>
            </Stack>
          ))}
          {/* qr code 기반 */}
          <Typography variant="h6" mt={6.5} mb={1}>
            관객과 기획사 모두가 편한 QR코드 기반 E-Ticket
          </Typography>
          {/* ticket list */}
          {TicketList.map((item, i) => (
            <Typography
              key={i}
              variant="body1"
              sx={{
                position: "relative",
                pl: 3,
                "&:nth-of-type(4)": {
                  "&:before": {
                    top: "25%",
                  },
                },
                "&:before": {
                  position: "absolute",
                  top: "50%",
                  left: 12,
                  transform: "translateY(-50%)",
                  content: '""',
                  width: "5px",
                  height: "5px",
                  bgcolor: "black",
                  display: "inline-block",
                },
              }}
            >
              {item.text}
            </Typography>
          ))}

          {/* 동그라미 */}
          <Typography variant="h6" sx={{ mt: 5, mb: 1 }}>
            티켓 확인은 단 한번으로 끝
          </Typography>
          <RoundText items={TicketRound} />
        </Box>
      </Stack>
    </>
  ),
  Locker: () => (
    <>
      {LockerItems.map((item, i) => (
        <Box key={i} mb={i === 0 && 6}>
          <Typography variant="h4" color={"primary.main"} mb={2}>
            {item.label}
          </Typography>
          <Stack direction="row" spacing={6}>
            {/* img */}
            <Box
              component="img"
              src={item.src}
              sx={{ width: "26%", borderRadius: 1.5 }}
            />
            <Box>
              <Typography variant="h6">{item.title}</Typography>
              {item.text.map((text) => (
                <Typography
                  key={text}
                  variant="body"
                  sx={{
                    mt: 3,
                    display: "block",
                    lineHeight: "24px",
                    whiteSpace: "pre",
                  }}
                >
                  {text}
                </Typography>
              ))}
            </Box>
          </Stack>
        </Box>
      ))}
    </>
  ),
  // Etc: () => <ServiceList items={EtcList} />,
};

export function RoundText({ items, sx }) {
  return (
    <Stack direction="row" sx={{ ...sx }}>
      {items.map((item, i) => (
        <Stack direction="row" alignItems="center" key={i}>
          <Box
            sx={{
              border: "1px solid",
              borderColor: "grey.999",
              borderRadius: "50%",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              lineHeight={1.5}
              sx={{ whiteSpace: "pre", fontWeight: 500 }}
            >
              {item.text}
            </Typography>
          </Box>
          {i < items.length - 1 && (
            <SvgIconStyle
              src={ArrowRight.src}
              size={16}
              sx={{ color: "primary.main", mx: 3 }}
            />
          )}
        </Stack>
      ))}
    </Stack>
  );
}

export const ContactComp = {
  Faq: (item) => (
    <CustomerAccordion key={item.id} item={item || "-"} category />
  ),

  Notice: (item) => <CustomerAccordion key={item.id} item={item} />,
  // Inquiry: () => (
  //   <Box>
  //     <Typography>inquiry</Typography>
  //   </Box>
  // ),
};

export function ServiceList({ items, sx }) {
  return (
    <Box sx={{ ...sx }}>
      {items.map((item, i) => (
        <Box key={i}>
          <Stack direction="row" alignItems="baseline">
            <Typography>{i + 1}.</Typography>
            <Typography
              variant="body1"
              sx={{
                mt: items[0] === item ? 0 : 2,
                mb: 2,
                ml: 1,
                whiteSpace: "pre",
              }}
            >
              {item.title}
            </Typography>
          </Stack>
          {i < items.length - 1 && (
            <Divider
              sx={{
                width: "80%",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}

export function TabPanel({ active, children, ...other }) {
  return (
    <Box
      role="tabpanel"
      hidden={!active}
      sx={{
        width: "100%",
        height: "100%",
      }}
      {...other}
    >
      <Box>{children}</Box>
    </Box>
  );
}

export function RowLineText({ item, small }) {
  return (
    <Box
      sx={{
        position: "relative",
        "&:last-child:after": {
          display: "none",
        },
        "&:after": {
          position: "absolute",
          top: "50%",
          right: small ? "-30%" : "-60%",
          width: "1px",
          pb: small ? "20%" : "30%",
          bgcolor: small ? "grey.300" : "grey.400",
          transform: "translateY(-50%)",
          content: '""',
        },
      }}
    >
      <Typography
        variant={small ? "title4" : "h1"}
        sx={{
          color: small ? "primary.light" : "primary.main",
          fontWeight: "bold",
        }}
      >
        {item.label}
        {!small && "+"}
      </Typography>
      <Typography
        variant={small ? "body2" : "body"}
        sx={{
          fontWeight: "medium",
          color: small ? "dark" : "grey.100",
          lineHeight: small && 1.3,
        }}
      >
        {item.text}
      </Typography>
    </Box>
  );
}

export function MiniLine({ sx }) {
  return (
    <Box
      sx={{
        bgcolor: "grey.300",
        width: "20px",
        height: "2px",
        ...sx,
      }}
    />
  );
}

export function History({ isLeft, item, isLast }) {
  return (
    <Box
      sx={{
        width: "11px",
        height: "11px",
        mb: isLeft ? 10 : 8,
        borderRadius: "50%",
        bgcolor: "primary.main",
        mx: "auto",
        "&::after": !isLast
          ? {
              position: "absolute",
              content: '""',
              top: "100%",
              left: "0",
              right: "0",
              width: "1px",
              pb: isLeft ? 10 : 8,
              bgcolor: "grey.100",
              margin: "0 auto",
            }
          : {},
      }}
    >
      <Typography
        variant="body"
        sx={{
          color: "white",
          textAlign: isLeft ? "right" : "left",
          mx: "auto",
          position: "absolute",
          left: isLeft ? "-60%" : "60%",
          top: -5,
          whiteSpace: "pre",
          lineHeight: 1.4,
          width: "100%",
        }}
      >
        <strong style={{ fontSize: 16 }}>{item.year}</strong>
        <br />
        {item.text}
      </Typography>
    </Box>
  );
}

export function AboutBtn({ onClick }) {
  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2}>
      <Button
        variant="outlined"
        sx={{
          borderRadius: 10,
          py: 1,
          px: 3,
        }}
        onClick={() => onClick("download")}
      >
        <Typography variant="body1">소개서 다운로드</Typography>
      </Button>
      <Button
        variant="contained"
        sx={{
          borderRadius: 10,
          py: 1,
          px: 3,

          "&:hover": {
            bgcolor: "primary.main",
          },
        }}
        onClick={() => onClick("service")}
      >
        <Typography variant="body1">퀸즈 부가서비스 알아보기 →</Typography>
      </Button>
    </Stack>
  );
}

const StyledSlider = styled(Slider)(({ theme }) => ({
  height: "100%",
  position: "relative",
  ".slick-prev": {
    marginLeft: -35,
    background: `center/contain no-repeat url(${ArrowLeft})`,
    "&:hover,&:focus": {
      background: `center/contain no-repeat url(${ArrowLeft})`,
    },
  },
  ".slick-next": {
    marginRight: -35,
    background: `center/contain no-repeat url(${ArrowRight})`,
    "&:hover,&:focus": {
      background: `center/contain no-repeat url(${ArrowRight})`,
    },
  },
  ".slick-prev,.slick-next": {},
  ".slick-prev::before, .slick-next::before": {
    opacity: 0,
    display: "none",
  },
  "&.slick-slider": {
    marginRight: "30px",
    marginLeft: "30px",
    ".slick-list": {
      height: "100%",
      ".slick-track": {
        height: "100% ",
        ".slick-slide": {
          padding: "0px 5px",
          "&>div": {
            height: "100%",
          },
        },
      },
    },
  },
}));

const StyledInner = styled(Slider)(({ theme }) => ({
  "& .slick-dots": {
    position: "absolute",
    bottom: 20,
  },
  "& .slick-dots li": {
    margin: "0 0.6px",
    width: 12,
    height: 0,
  },
  "& .slick-dots li button:before": {
    color: theme.palette.grey[200],
    opacity: 100,
  },
  "& .slick-dots li.slick-active button:before": {
    color: theme.palette.primary.main,
  },
}));

export function PopUpModal({ show, close }) {
  const parentRef = useRef(null);
  const childRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    draggable: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const innerSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
  };

  return (
    <Modal
      open={show}
      onClose={close}
      closeAfterTransition
      sx={{
        display: "flex",
        position: "absolute",
        justifyContent: "center",
        top: "4%",
      }}
    >
      <Fade in={show}>
        <Box
          sx={{
            bgcolor: "black",
            width: "115vh",
            height: "80.5vh",
            borderRadius: 1,
            py: 8.2,
            px: 10,
            position: "relative",
          }}
        >
          <Button
            sx={{ position: "absolute", top: 30, right: 10 }}
            onClick={() => {
              close();
            }}
          >
            <SvgIconStyle src={CloseBtnIcon.src} size={16} color={"white"} />
          </Button>
          {/* slider */}

          <StyledSlider {...settings} ref={parentRef}>
            {[
              { color: "grey" },
              { color: "green" },
              { color: "yellow" },
              { color: "yellow" },
              { color: "yellow" },
            ].map((item, i) => (
              <Box key={i} sx={{ height: "100%" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  sx={{ height: "100%" }}
                >
                  <Box
                    component="img"
                    src={PortImg.src}
                    sx={{
                      width: "53.4%",
                      objectFit: "cover",
                      borderRadius: 2,
                      height: "100%",
                    }}
                  />

                  <Stack
                    justifyContent="space-between"
                    sx={{
                      width: "43.5%",
                      color: "white",
                    }}
                  >
                    <Box>
                      <Typography variant="title" sx={{ lineHeight: 1.2 }}>
                        WATERBOMB
                        <br />
                        INCHEON 2023
                      </Typography>
                      <Typography variant="body1" color={"grey.66"}>
                        <strong>2022.08.06</strong> | 장소
                      </Typography>
                      <Box
                        sx={{
                          width: "60%",
                          mt: 1,
                        }}
                      >
                        {[
                          { label: "F&B" },
                          { label: "E-Ticket" },
                          { label: "Locker" },
                          { label: "Parking Lot" },
                        ].map((item, i) => (
                          <Chip
                            key={i}
                            label={item.label}
                            variant="outlined"
                            sx={{
                              mr: 1.2,
                              mb: 1,
                              color: "primary.light",
                              borderColor: "primary.light",
                              fontSize: 22,
                              fontWeight: 500,
                            }}
                          />
                        ))}
                      </Box>
                    </Box>

                    {/* Innerslider */}
                    <StyledInner {...innerSettings} ref={childRef}>
                      {[
                        { color: "grey.300" },
                        { color: "green" },
                        { color: "yellow" },
                        { color: "blue" },
                        { color: "grey.300" },
                      ].map((item, i) => (
                        <Box key={i} sx={{ mt: 3, height: 207 }}>
                          <Box
                            component="img"
                            src={PortImg.src}
                            sx={{
                              bgcolor: item.color,
                              height: "100%",
                              width: "100%",
                              borderRadius: 1,
                              objectFit: "cover",
                            }}
                          />
                        </Box>
                      ))}
                    </StyledInner>
                  </Stack>
                </Stack>
              </Box>
            ))}
          </StyledSlider>
        </Box>
      </Fade>
    </Modal>
  );
}

export function CustomerAccordion({ other, sx, category, item }) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      sx={{
        "&.Mui-expanded": {
          "&:before": {
            display: "none",
          },
        },
        "&:last-child": {
          borderBottom: "none",
        },
        "&:before": {
          border: "none",
          opacity: 0,
        },
        ...sx,
      }}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          pl: 3.8,
          borderBottom: "1px solid ",
          borderColor: "grey.500",
        }}
      >
        <Stack direction="row">
          {category?.length ? (
            <Typography
              variant="body"
              fontWeight={expanded ? 700 : 400}
              mr={0.5}
            >
              &#91;{item.category}&#93;
            </Typography>
          ) : null}
          <Typography variant="body" fontWeight={expanded ? 700 : 400}>
            {item.title}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          p: 0,
        }}
      >
        <Box
          dangerouslySetInnerHTML={{ __html: item.content }}
          sx={{ backgroundColor: "grey.soft", p: 3.8, color: "grey.66" }}
        />
      </AccordionDetails>
    </Accordion>
  );
}

// export function PortFolioRow({ items, direction = "left", len, speed }) {
//   const getContainerWidth = (len) => `calc((15vw + 16px) * ${len})`;
//   const minusLen = -len;
//   return (
//     <Stack
//       direction="row"
//       spacing={2}
//       sx={{
//         mt: 2,
//         flexWrap: "nowrap",
//         "&::-webkit-scrollbar": { display: "none" },
//         animation: `move-${direction} ${len * speed}s infinite linear`,
//         [direction === "right"
//           ? "@keyframes move-right"
//           : "@keyframes move-left"]: {
//           from: {
//             transform:
//               direction === "right"
//                 ? `translateX(${getContainerWidth(minusLen)})`
//                 : "translateX(0)",
//           },
//           to: {
//             transform:
//               direction === "right"
//                 ? "translateX(0)"
//                 : `translateX(${getContainerWidth(minusLen)})`,
//           },
//         },
//         "&:hover": {
//           overflow: "scroll",
//           animation: "none",
//         },
//       }}
//     >
//       {items.map((_, i) => (
//         <Box
//           key={i}
//           item
//           sx={{
//             width: "15vw",
//             minWidth: "15vw",
//             maxWidth: "15vw",
//           }}
//         >
//           <Button
//             sx={{
//               p: 0,

//               minHeight: 0,
//               width: "100%",
//               pb: "120%",
//               bgcolor: "grey.middle",
//               borderRadius: 0,
//               background: `100% no-repeat url(${PortImg})`,
//               backgroundSize: "cover",
//               height: "100%",
//               "&:hover": {
//                 bgcolor: "transparent",
//               },
//             }}
//             // onClick={() => setShow(true)}
//           />
//         </Box>
//       ))}
//       {/* clone */}
//       {items.map((_, i) => (
//         <Box
//           key={i}
//           item
//           sx={{
//             width: "15vw",
//             minWidth: "15vw",
//             maxWidth: "15vw",
//           }}
//         >
//           <Button
//             sx={{
//               p: 0,

//               minHeight: 0,
//               width: "100%",
//               pb: "130%",
//               bgcolor: "grey.middle",
//               borderRadius: 0,
//               background: `100% no-repeat url(${PortImg})`,
//               backgroundSize: "cover",
//               height: "100%",
//               "&:hover": {
//                 bgcolor: "transparent",
//               },
//             }}
//             // onClick={() => setShow(true)}
//           />
//         </Box>
//       ))}
//     </Stack>
//   );
// }

export const PortFolioRow = forwardRef(
  ({ items, direction = "left", len, speed, setShow }, ref) => {
    const getContainerWidth = (len) => `calc((15vw + 16px) * ${len})`;
    const minusLen = -len;
    return (
      <Stack
        ref={ref}
        direction="row"
        spacing={2}
        sx={{
          mt: 2,
          flexWrap: "nowrap",
          "&::-webkit-scrollbar": { display: "none" },
          animation: `move-${direction} ${len * speed}s infinite linear`,
          [direction === "right"
            ? "@keyframes move-right"
            : "@keyframes move-left"]: {
            from: {
              transform:
                direction === "right"
                  ? `translateX(${getContainerWidth(minusLen)})`
                  : "translateX(0)",
            },
            to: {
              transform:
                direction === "right"
                  ? "translateX(0)"
                  : `translateX(${getContainerWidth(minusLen)})`,
            },
          },
          "&:hover": {
            animationPlayState: "paused",
          },
        }}
      >
        {items.map((_, i) => (
          <Box
            key={i}
            item
            sx={{
              width: "15vw",
              minWidth: "15vw",
              maxWidth: "15vw",
            }}
          >
            <Button
              sx={{
                p: 0,
                minHeight: 0,
                width: "100%",
                pb: "120%",
                bgcolor: "grey.middle",
                borderRadius: 1.5,
                background: `100% no-repeat url(${PortImg})`,
                backgroundSize: "cover",
                height: "100%",
                "&:hover": {
                  bgcolor: "transparent",
                },
              }}
              onClick={() => setShow(true)}
            />
          </Box>
        ))}
        {/* clone */}
        {items.map((_, i) => (
          <Box
            key={i}
            item
            sx={{
              width: "15vw",
              minWidth: "15vw",
              maxWidth: "15vw",
            }}
          >
            <Button
              sx={{
                p: 0,
                minHeight: 0,
                width: "100%",
                pb: "130%",
                bgcolor: "grey.middle",
                borderRadius: 1.5,
                background: `100% no-repeat url(${PortImg})`,
                backgroundSize: "cover",
                height: "100%",
                "&:hover": {
                  bgcolor: "transparent",
                },
              }}
              onClick={() => setShow(true)}
            />
          </Box>
        ))}
      </Stack>
    );
  }
);
